export default __webpack_public_path__ + "static/media/010.99cc37f9.jpg";